import { Pagination } from '@/domain/models'
import {
  AccountDependentSearchModel,
  AccountDependentSearchRequestModel
} from '@/domain/models/account/company-manager/account-dependent-search-result'

export interface AccountDependentSearch {
  search(searchCriteria: AccountDependentSearch.RequestModel): Promise<AccountDependentSearch.Model>
  loader(searchCriteria: AccountDependentSearch.RequestModel): Promise<AccountDependentSearch.Model>
}

export namespace AccountDependentSearch {
  export type Model = Pagination.Pageable<AccountDependentSearchModel>
  export type ItemModel = AccountDependentSearchModel
  export type RequestModel = AccountDependentSearchRequestModel
  export const Key = 'account-dependent-search'
  export const NAME_PARAM_NAME = 'name'
  export const EMAIL_PARAM_NAME = 'email'
  export const DEFAULT_PAGE_SIZE = 30
  export const DEFAULT_ROWS_PER_PAGE_OPTIONS = [15, 30, 45]
}
